import { localizedLegalPage } from "./localized";
import { PrivacyPage as Fr } from "./fr/PrivacyPage";
import { PrivacyPage as En } from "./en/PrivacyPage";

export const PrivacyPage = localizedLegalPage({ fr: Fr, en: En });

export default PrivacyPage;
